import { type ReactNode } from 'react';
import { useAuth } from './AuthProvider.js';
import { LoginPrompt } from './components/LoginPrompt.js';

interface RequireAuthProps {
  children: ReactNode;
  /** Optional content shown while we resolve auth state. */
  loadingFallback?: ReactNode;
}

export function RequireAuth({ children, loadingFallback }: RequireAuthProps): JSX.Element {
  const { user, loading, sessionRevoked, signIn } = useAuth();

  if (loading) {
    return <>{loadingFallback ?? <DefaultLoading />}</>;
  }

  if (!user) {
    return (
      <LoginPrompt
        onSignIn={() => signIn()}
        notice={sessionRevoked ? 'This session was signed out everywhere. Continue to sign in again.' : undefined}
      />
    );
  }

  return <>{children}</>;
}

function DefaultLoading(): JSX.Element {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-sm text-[var(--color-muted)]">Loading…</div>
    </div>
  );
}
